import {
  MonthDayWithToday,
  MonthNotificationBadge
} from '../../../Css/StyledCalendarMonth.js';

import {
  MobileMonthContainer,
  MobileMonthHeader,
  MobileMonthHeaderCell,
  MobileWeekRow,
  MobileWeekGrid,
  MobileEmptyDay,
  MobileMonthDayWithToday,
} from '../../../Css/StyledCalendarMobile.js';

import {
  getAppointmentsForDate
} from '../../../../utils/calendarUtils.js';

import {
  TURN_TYPES,
  normalizeTurnType
} from '../../../../constants/calendarConstants.js';

import MobileScrollWrapper from './MobileScrollWrapper.js';

const MONTH_DAY_NAMES = [
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
  'Domingo'
];

const getMonthEventSummary = (appointments = []) => {
  const summary = {
    sesionPaciente: 0,
    reunionPadres: 0,
    reunionColegio: 0,
    reunionProfesionales: 0
  };

  appointments.forEach((appointment) => {
    const tipoTurno = normalizeTurnType(appointment?.tipo_turno);

    if (tipoTurno === TURN_TYPES.SESION_PACIENTE) {
      summary.sesionPaciente += 1;
      return;
    }

    if (tipoTurno === TURN_TYPES.REUNION_PADRES) {
      summary.reunionPadres += 1;
      return;
    }

    if (tipoTurno === TURN_TYPES.REUNION_COLEGIO) {
      summary.reunionColegio += 1;
      return;
    }

    if (tipoTurno === TURN_TYPES.REUNION_PROFESIONALES) {
      summary.reunionProfesionales += 1;
    }
  });

  return summary;
};

const isSameDate = (dateA, dateB) => {
  if (!dateA || !dateB) {
    return false;
  }

  return (
    dateA.getFullYear() === dateB.getFullYear() &&
    dateA.getMonth() === dateB.getMonth() &&
    dateA.getDate() === dateB.getDate()
  );
};

const MobileMonthView = ({
  monthDays,
  totalRows,
  highlightDay,
  appointments = [],
  referenceDate = new Date(),
  onDayClick,
}) => {
  const weeks = [];

  for (let i = 0; i < monthDays.length; i += 7) {
    weeks.push(monthDays.slice(i, i + 7));
  }

  const referenceYear = referenceDate.getFullYear();
  const referenceMonth = referenceDate.getMonth();

  const today = new Date();

  return (
    <MobileScrollWrapper>
      <MobileMonthContainer>
        <MobileMonthHeader>
          {MONTH_DAY_NAMES.map((dayName, index) => (
            <MobileMonthHeaderCell key={`mobile-header-${index}`}>
              {dayName.charAt(0)}
            </MobileMonthHeaderCell>
          ))}
        </MobileMonthHeader>

        {weeks.map((week, weekIndex) => (
          <MobileWeekRow key={`mobile-week-${weekIndex}`}>
            <MobileWeekGrid>
              {week.map((day, dayIndex) => {
                if (!day) {
                  return (
                    <MobileEmptyDay key={`mobile-empty-${weekIndex}-${dayIndex}`} />
                  );
                }

                const cellDate = new Date(referenceYear, referenceMonth, day);

                const dayAppointments = getAppointmentsForDate(
                  appointments,
                  cellDate
                );

                const eventSummary = getMonthEventSummary(dayAppointments);

                const isToday = isSameDate(cellDate, today);

                return (
                  <MobileMonthDayWithToday
                    key={`mobile-day-${weekIndex}-${dayIndex}`}
                    isToday={isToday}
                    onClick={() => {
                      if (onDayClick) {
                        onDayClick(cellDate);
                      }
                    }}
                    style={{
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                  >
                    <MonthDayWithToday
                      active={isToday}
                      isToday={isToday}
                    >
                      {day}
                    </MonthDayWithToday>

                    {eventSummary.sesionPaciente > 0 && (
                      <MonthNotificationBadge
                        position="topLeft"
                        variant="ok"
                        title={`${eventSummary.sesionPaciente} sesión(es) con paciente`}
                      >
                        {eventSummary.sesionPaciente}
                      </MonthNotificationBadge>
                    )}

                    {eventSummary.reunionPadres > 0 && (
                      <MonthNotificationBadge
                        position="topRight"
                        variant="padres"
                        title={`${eventSummary.reunionPadres} reunión(es) con padres`}
                      >
                        {eventSummary.reunionPadres}
                      </MonthNotificationBadge>
                    )}

                    {eventSummary.reunionColegio > 0 && (
                      <MonthNotificationBadge
                        position="bottomLeft"
                        variant="colegio"
                        title={`${eventSummary.reunionColegio} reunión(es) con colegio`}
                      >
                        {eventSummary.reunionColegio}
                      </MonthNotificationBadge>
                    )}

                    {eventSummary.reunionProfesionales > 0 && (
                      <MonthNotificationBadge
                        position="bottomRight"
                        variant="profesionales"
                        title={`${eventSummary.reunionProfesionales} reunión(es) con profesionales`}
                      >
                        {eventSummary.reunionProfesionales}
                      </MonthNotificationBadge>
                    )}
                  </MobileMonthDayWithToday>
                );
              })}
            </MobileWeekGrid>
          </MobileWeekRow>
        ))}
      </MobileMonthContainer>
    </MobileScrollWrapper>
  );
};

export default MobileMonthView;